import styled from 'styled-components';

export const StyledHistoricalVisitPrescriptionHeader = styled.div`
   display: flex;
   flex-direction: column;

   > span {
      font-size: 11px;
   }
`;

StyledHistoricalVisitPrescriptionHeader.displayName = 'StyledHistoricalVisitPrescriptionHeader';
